import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadPresetsFailed, loadPresetsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadPresets(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/violation-presets`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK && data.data) {
      yield put(loadPresetsSuccessful(data.data));
      yield call(resolveActionPromise(action));
    } else {
      yield put(loadPresetsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadPresetsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
